/** @format */
import style from "./index.module.scss";
import { useEffect, useState } from "react";

const ModalInput = ({ middleware, type = "text", placeholder, controller }) => {
    const [value, setValue] = controller;

    return (
        <input
            className={style.inputModal}
            type={type}
            value={value}
            placeholder={placeholder}
            onChange={(e) => {
                setValue(e.target.value);
            }}
            onKeyUp={(e) => middleware(e.target.value)}
        />
    );
};
export default ModalInput;
